import React from "react";
import {Outlet} from "react-router";

export default function Apps() {
    return (
        <div>
            <Outlet/>
        </div>
    )
}